import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from "../assets/img/logo-dark.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const email = localStorage.getItem('email'); 
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('loginbody');
    return () => {
      document.body.classList.remove('loginbody');
    };
  }, []);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('http://3.131.161.69:5000/admin/reset-password', {
        email,
        newPassword,
        confirmPassword,
      });

      if (response.status === 200) {
        // Password reset successful
        toast.success("Password reset successfully");
        navigate('/');
      }
    } catch (err) {
      // Handle errors (validation, server errors)
      setErrorMessage(err.response?.data?.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <React.Fragment>
      <Row className="justify-content-center">
        <Col lg={6} className="loginform">
          <div className="loginmain_div maxwidth500 mx-auto">
            <div className="headlogin_div mb-4">
              <img className="loginlogo_img" src={logo} alt=""/>
              <h2>Reset Password</h2>
              <p>Please enter the details below to reset your password.</p>
            </div>
            <Form onSubmit={handleResetPassword}>
              {errorMessage && <p className="text-danger">{errorMessage}</p>}
              <Form.Group className="mb-4 form-group">
                <Form.Label>New Password</Form.Label>
                <Form.Control 
                  type="password" 
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)} 
                />
              </Form.Group>
              <Form.Group className="mb-4 form-group">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control 
                  type="password" 
                  placeholder="Enter confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)} 
                />
              </Form.Group>
              <Button type="submit" className="btn btn-primary w-100">Reset Password</Button>
              <p className="formfooter text-center mt-3">Back To <Link to="/">Login</Link></p>
            </Form>
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </React.Fragment>
  );
}
